import { apiGet, apiPatch, apiPost, apiPut } from './apiClient';
import type {
  CreatePersonalMailboxBody,
  CreateSharedMailboxBody,
  MailAdminCandidateDto,
  MailAdminMailboxDto,
  MailAdminMemberInput,
  UpdateMailboxBody,
} from './mailAdminTypes';

const enc = encodeURIComponent;

export const listAdminMailboxes = () => apiGet<MailAdminMailboxDto[]>('/mail/admin/mailboxes');

export const listAdminCandidates = () => apiGet<MailAdminCandidateDto[]>('/mail/admin/candidates');

export const createPersonalMailbox = (body: CreatePersonalMailboxBody) =>
  apiPost<MailAdminMailboxDto>('/mail/admin/mailboxes/personal', body);

export const createSharedMailbox = (body: CreateSharedMailboxBody) =>
  apiPost<MailAdminMailboxDto>('/mail/admin/mailboxes/shared', body);

export const updateMailbox = (id: string, body: UpdateMailboxBody) =>
  apiPatch<MailAdminMailboxDto>(`/mail/admin/mailboxes/${enc(id)}`, body);

export const setMailboxMembers = (id: string, members: MailAdminMemberInput[]) =>
  apiPut<MailAdminMailboxDto>(`/mail/admin/mailboxes/${enc(id)}/members`, { members });
